import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { TrendingUp as TrendingUpIcon } from '@mui/icons-material';

interface LogoProps {
  height?: number;
  withText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ height = 40, withText = true }) => {
  const theme = useTheme();
  
  const iconSize = height * 0.8;
  const fontSize = height * 0.5;
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        height: height,
      }}
    >
      <TrendingUpIcon
        sx={{
          color: 'primary.main',
          fontSize: iconSize,
          mr: withText ? 1 : 0,
        }}
      />
      
      {withText && (
        <Typography
          variant="h6"
          component="div"
          sx={{
            fontWeight: 'bold',
            fontSize: fontSize,
            lineHeight: 1,
            letterSpacing: '0.02em',
            color: theme.palette.mode === 'dark' ? 'white' : 'text.primary',
          }}
        >
          SEO<span style={{ color: theme.palette.primary.main }}>Dashboard</span>
        </Typography>
      )}
    </Box>
  );
};

export default Logo;